<div>
  <label [for]="id + '-dropdown-select'"
    >{{ label }} <ng-container *ngTemplateOutlet="afterLabelTemplate!"></ng-container> </label
  ><select
    class="form-control"
    [attr.id]="id + '-dropdown-select'"
    [disabled]="disabled"
    (change)="onChange($event)"
  >
    @for (value of possibleValues; track value) {
      <option [value]="getId(value)" [selected]="optionCompareFunction(selectedValue, value)">
        {{ optionLabelFunction(value) }}
      </option>
    }
  </select>
</div>
